// extracted by mini-css-extract-plugin
module.exports = {"image":"why-should-you-get_image__2lIWK","section_title":"why-should-you-get_section_title__1mwQz","features_list":"why-should-you-get_features_list__16kqz"};